import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDecreaseImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", {}), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		focusable: "false",
		children: [/* @__PURE__ */ _jsx("path", { d: "M11.9,6.7v-3.1h-6.6c-.9,0-1.6.7-1.6,1.6v11.4c0,.9.7,1.6,1.6,1.6h11.4c.9,0,1.6-.7,1.6-1.6V6.7h-6.4ZM5.3,15.9l2.9-3.7,2,2.5,2.9-3.7,3.7,4.9H5.3Z" }), /* @__PURE__ */ _jsx("rect", {
			x: 12.8,
			y: 4,
			width: 7.3,
			height: 1.8
		})]
	})]
});
export default SvgDecreaseImage;
